// extracted by mini-css-extract-plugin
module.exports = {"container":"BottomNav_container__3jw21","menuItem":"BottomNav_menuItem__2pOMv","active":"BottomNav_active__21sba","wishListCount":"BottomNav_wishListCount__1P_2D"};